import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

// Return true only when the current form is complete. Never start order work
// while the user is still choosing the customer/commercial context.
export function confirmarInfoPedido(vm) {
  if (vm.$store.getters['InfoPedido/GET_VALIDATION_FORM_INFO_PEDIDO']) return true;
  vm.$bvModal.show('modal-center-info-pedido');
  vm.$toast({
    component: ToastificationContent,
    props: {
      title: 'Preencha as informações do pedido',
      text: 'Complete e confirme o Info. Pedido para continuar.',
      icon: 'AlertCircleIcon',
      variant: 'warning',
    },
  });
  return false;
}
